import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

const AutocompleteTemplate = ({ id, title, options, defaultValue, setValue, name = null, disabled=false }) => {
  const [selectedValue, setSelectedValue] = useState('');

  const setNewValue = (value) => {
    setSelectedValue(value);
    setValue(id, value);
  }

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, []);

  return (<>
    <Autocomplete
      className={title}
      limitTags={-1}
      id="options"
      options={options || []} 
      value={selectedValue}
      freeSolo
      disabled={disabled}
      getOptionLabel={(option) => option["label"] || ""}
      renderInput={(params) => (
        <TextField
          {...params}
          label={title}
          placeholder={title}
          // required
        />
      )}
      onChange={(_, newValue) => {
        setNewValue(newValue);
      }}
      sx={{ width: "250px" }}
    /></>
  )
};
export default AutocompleteTemplate;